<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="showForm3(null)">新增客户</el-button>
        <!-- <el-button type="primary" @click="showForm(null)">新增油罐客户</el-button> -->
        <!-- <el-button type="primary" style="margin-left:10px" @click="showForm2(null)">新增成品油客户</el-button> -->
      </template>
      <el-form :model="searchForm" ref="formData" inline class="global-form-label-width account-form"
               label-width="100px">
        <el-form-item label="姓名" prop='userName'>
          <el-input clearable v-model="searchForm.userName" placeholder="姓名" />
        </el-form-item>

        <!-- 新增 客户类型下拉 -->
        <el-form-item v-if="activeName !== '4'" label="客户类型" prop="userType">
          <el-select v-model="searchForm.userType" placeholder="请选择客户类型" clearable>
            <template v-for="(item) of userTypeOptions">
              <el-option v-if="['2', '3'].includes(item.key)" :label="item.value" :value="item.key" :key="item.key"></el-option>
            </template>
          </el-select>
        </el-form-item>

        <!-- 新增 业务员模糊搜索 -->
        <el-form-item label="业务员" prop="serviceUserName">
          <el-input clearable v-model="searchForm.serviceUserName" placeholder="业务员名称" />
        </el-form-item>

        <el-form-item label="手机号" prop="mobile">
          <el-input clearable v-model="searchForm.mobile" placeholder="手机号" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="客户" name="2,3"></el-tab-pane>
        <el-tab-pane label="供应商" name="4"></el-tab-pane>
      </el-tabs>
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="120" label="客户名称" prop="userName"></el-table-column>
        <!-- 展示往来单位编码和独立账套编码，便于检查采购方资料。 -->
        <el-table-column min-width="120" label="客户/供应商编码" prop="userNo"></el-table-column>
        <el-table-column min-width="120" label="账套编码" prop="accountSetCode"></el-table-column>
        <el-table-column min-width="120" label="客户类型" prop="userType">
          <template v-slot="{ row }">
            <span>{{row.userType.split(',').map(item => userTypeMap.get(item)).join()}}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="登录账号" prop="loginId"></el-table-column>
        <el-table-column min-width="120" label="业务员" prop="serviceUserName"></el-table-column>
        <el-table-column min-width="120" label="手机号" prop="mobile"></el-table-column>
        <el-table-column min-width="120" label="角色" prop="roleName"></el-table-column>
        <el-table-column width="250" label="操作" fixed="right">
          <template v-slot="{ row }">
            <template v-if="row.isAdmin === '0'">
              <el-button type="text" v-if="hasEdit"
                         @click=" $router.push('/system/khUser/edit?userId=' + row.userId)">编辑</el-button>
              <el-button type="text" @click="$router.push('/system/ygUser/detail?userId=' + row.userId)">详情</el-button>
              <el-button type="text" @click="resetPassword(row.userId)">重置密码</el-button>
              <el-button type="text" v-if="row.userId !== '2021020603' && hasDelete" @click="deleteRow(row.userId)"
                         class="del-btn">删除</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
                     @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
import { userType } from '@/utils/dict'
export default {
  name: 'YgUserList',
  mixins: [keepAlive],
  data() {
    return {
      activeName: '2,3',
      userTypeMap: userType,
      // 把字典转为下拉选项
      userTypeOptions: [],
      tableData: [],
      roles: [],
      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        userName: null,
        mobile: '',
        roleId: '',
        deptId: '',
        userType: '',
        serviceUserName: ''
      },
      dialogVisible: false,
      cpyTypeList: []
    }
  },
  created() {
    // Map字典转数组，用于下拉
    this.userTypeOptions = Array.from(userType, ([key, value]) => ({ key, value }))
    this.loadData()
    this.loadRoles()
  },
  computed: {
    deptData() {
      return this.$store.state.deptList
    },
    buttonList() {
      // return this.$store.state.buttonList.map(item => item.butCode)
      return this.$store.getters.getMenuByCode('KFGYSGL')
    },
    hasDelete() {
      return this.buttonList.includes('delete')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasAdd() {
      return this.buttonList.includes('add')
    }
  },
  methods: {
    handleClick() {
      this.searchForm.userType = ''
      this.onSearch()
    },
    loadRoles() {
      this.$axios.get(this.$apis.system.selectSysRoleByList).then(res => {
        this.roles = res
      })
    },
    getCpyTypeList() {
      this.$axios.get(this.$apis.oiltabkManage.selectYgOilTypeByPage, {
        page: 1,
        size: 999
      }).then(res => {
        this.cpyTypeList = res.list
      })
    },
    closeCascader() {
      this.$refs.cascader.dropDownVisible = false
    },
    loadData() {
      const params = {
        page: this.page,
        mobile: this.searchForm.mobile,
        userType: this.searchForm.userType || this.activeName,
        userName: this.searchForm.userName,
        roleId: this.searchForm.roleId,
        serviceUserName: this.searchForm.serviceUserName
      }
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        params: params
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.formData.resetFields()
      this.onSearch()
    },
    showForm() {
      this.$router.push('/system/ygUser/add')
    },
    showForm2() {
      this.$router.push('/system/cpyUser/add')
    },
    showForm3() {
      this.$router.push('/system/khUser/add')
    },
    resetPassword(userId) {
      this.$confirm('重置后的密码为用户手机号后六位, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.system.resetPassword, {
          userId
        }).then(() => {
          this.loadData()
        })
      })
    },
    deleteRow(userId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.system.eliminateIparkUser, {
          userId
        }).then(() => {
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
// .el-select {
//   width: 100%;
// }
</style>
<style lang='scss'>
.account-form {
  .el-select,
  .el-input,
  .el-cascader {
    width: 200px !important;
  }
}
</style>
